module.exports = __webpack_public_path__ + "static/media/Onlinecykel.12be2137.png";